/**
 * Route Dependencies
 */
const ProjectGaap = r => require.ensure([], () => r(require('../components/projects/single/ProjectGaap')), 'view-project')
const ProjectDebt = r => require.ensure([], () => r(require('../components/projects/single/ProjectDebt')), 'view-project')
const ProjectOpex = r => require.ensure([], () => r(require('../components/projects/single/ProjectOpex')), 'view-project')
const ProjectCapex = r => require.ensure([], () => r(require('../components/projects/single/ProjectCapex')), 'view-project')
const ProjectIncome = r => require.ensure([], () => r(require('../components/projects/single/ProjectIncome')), 'view-project')
const ProjectEquity = r => require.ensure([], () => r(require('../components/projects/single/ProjectEquity')), 'view-project')
const ProjectWarRoom = r => require.ensure([], () => r(require('../components/projects/views/ProjectWarRoom')), 'view-project')
const ProjectSummary = r => require.ensure([], () => r(require('../components/projects/single/ProjectSummary')), 'view-project')
const ProjectCashFlow = r => require.ensure([], () => r(require('../components/projects/single/ProjectCashFlow')), 'view-project')
const ProjectDevBudget = r => require.ensure([], () => r(require('../components/projects/single/ProjectDevBudget')), 'view-project')
const ProjectClosingCosts = r => require.ensure([], () => r(require('../components/projects/single/ProjectClosingCosts')), 'view-project')

/**
 * View Project Routes
 */
export default [
    {
        path: '',
        name: 'projects.view.tearsheet',
        component: ProjectSummary
    },
    {
        path: 'development-budget',
        name: 'projects.view.devbudget',
        component: ProjectDevBudget
    },
    {
        path: 'income',
        name: 'projects.view.income',
        component: ProjectIncome
    },
    {
        path: 'gaap',
        name: 'projects.view.gaap',
        component: ProjectGaap
    },
    {
        path: 'cash_flow',
        name: 'projects.view.cash_flow',
        component: ProjectCashFlow
    },
    {
        path: 'opex',
        name: 'projects.view.opex',
        component: ProjectOpex
    },
    {
        path: 'capex',
        name: 'projects.view.capex',
        component: ProjectCapex
    },
    {
        path: 'equity',
        name: 'projects.view.equity',
        component: ProjectEquity
    },
    {
        path: 'debt',
        name: 'projects.view.debt',
        component: ProjectDebt
    },
    {
        path: 'closing-costs',
        name: 'projects.view.closing_costs',
        component: ProjectClosingCosts
    },
    {
        path: 'war-room',
        name: 'projects.view.war_room',
        component: ProjectWarRoom
    }
]



// WEBPACK FOOTER //
// ./src/router/view-project.js